import { Location } from "./types";

/**
 * Get all unique areas from active locations
 * @param locations Array of location objects
 * @returns Array of unique area names from active locations
 */
export const getActiveAreas = (locations: Location[]): string[] => {
  if (!locations || locations.length === 0) return [];
  
  const activeLocations = locations.filter(location => location.status === "active");
  const areas = activeLocations
    .map(location => location.area)
    .filter((area): area is string => !!area); // Filter out undefined areas
  
  return Array.from(new Set(areas)); // Remove duplicates
};

/**
 * Get locations that match the given areas
 * @param locations Array of location objects
 * @param areas Array of area names to filter by
 * @returns Array of location shortNames that match the given areas
 */
export const getLocationsByAreas = (locations: Location[], areas: string[]): string[] => {
  if (!locations || locations.length === 0 || !areas || areas.length === 0) return [];
  
  const activeLocations = locations.filter(location => location.status === "active");
  const matchingLocations = activeLocations
    .filter(location => location.area && areas.includes(location.area))
    .map(location => location.shortName)
    .filter((shortName): shortName is string => !!shortName); // Filter out undefined shortNames
  
  return matchingLocations;
};

/**
 * Get area options for dropdowns/filters
 * @param locations Array of location objects
 * @returns Array of objects with label and value for area selection
 */
export const getAreaOptions = (locations: Location[]): Array<{ label: string; value: string }> => {
  const areas = getActiveAreas(locations);
  return areas.map(area => ({ label: area, value: area }));
};
